import api from '../api-methods'

const proxyIm = process.env.VUE_APP_ENV === 'local' ? '/proxy_im' : process.env.VUE_APP_IM

const im = {
  // 获取链接nim的token
	getNimToken: token => {
		return api.post(proxyIm + '/v1/users', {
      token
    })
	},
}
export default im
